import React from "react";
import { useState } from "react";
import useProcessSpendingData from "./useProcessSpendData";
import TabLayout from "../../components/TabLayout";
import MonthlyTotalsTable from "../../components/MonthlyTotalsTable";
import MultiBusinessTotalsTable from "../../components/MultiBusinessTotalsTable";
import SpendingDetails from "../../components/SpendingDetails";

const SpendingAverages = () => {
	const { compiledData } = useProcessSpendingData({ startDate: "2025-01-01", endDate: "2025-11-31", categoriesToExclude: ["Erin Paycheck"] });
	const [details, setDetails] = useState(null);

	console.log("Compiled Data:", compiledData);

	return (
		<div className="spending-averages">
			<TabLayout
				container="tab-section lavella-life"
				tabs={[
					{
						title: "Home",
						content: (
							<>
								<h4>Home</h4>
								<MonthlyTotalsTable
									selectedBusiness="Home"
									businessData={compiledData.filter((obj) => obj.business === "Home")[0]}
									// Add categories to ignore here, e.g. ["Dinner","Uber"]
									excludedCategories={[]}
									onShowDetails={setDetails}
								/>
								<h4>Apartment</h4>
								<MonthlyTotalsTable selectedBusiness="Apartment" businessData={compiledData.filter((obj) => obj.business === "Apartment")[0]} onShowDetails={setDetails} />
								<h4>Other</h4>
								<MonthlyTotalsTable selectedBusiness="Other" businessData={compiledData.filter((obj) => obj.business === "Other")[0]} onShowDetails={setDetails} />
								<h4>Totals</h4>
								<MultiBusinessTotalsTable selectedBusinesses={["Home", "Other", "Apartment"]} compiledData={compiledData} />
							</>
						),
					},
					{
						title: "Business",
						content: (
							<>
								<h4>NL</h4>
								<MonthlyTotalsTable selectedBusiness="NL" businessData={compiledData.filter((obj) => obj.business === "NL")[0]} onShowDetails={setDetails} />
								<h4>Immerge</h4>
								<MonthlyTotalsTable selectedBusiness="Immerge" businessData={compiledData.filter((obj) => obj.business === "Immerge")[0]} onShowDetails={setDetails} />
								<h4>Projects</h4>
								<MonthlyTotalsTable selectedBusiness="Projects" businessData={compiledData.filter((obj) => obj.business === "Projects")[0]} onShowDetails={setDetails} />
							</>
						),
					},
				]}
			/>
			<SpendingDetails entries={details?.entries || []} title={details?.title} active={!!details} onClose={() => setDetails(null)} />
		</div>
	);
};

export default SpendingAverages;
